import { gql } from '@apollo/client';

export const CREATE_RESUME = gql`
  mutation CreateResume(
    $categoryId: ID
    $dateOfBirth: ISO8601Date
    $description: String
    $email: String
    $educationId: ID
    $experienceId: ID
    $firstName: String
    $gender: GenderEnum
    $patronymic: String
    $personal: String
    $phones: [String!]
    $photo: Upload
    $positionName: String
    $regionId: ID
    $salaryFrom: Int
    $skills: String
    $surname: String
    $educationInfo: String
    $experienceInfo: String
    $isDraft: Boolean
  ) {
    createResume(
      input: {
        categoryId: $categoryId
        dateOfBirth: $dateOfBirth
        description: $description
        email: $email
        educationId: $educationId
        experienceId: $experienceId
        firstName: $firstName
        gender: $gender
        patronymic: $patronymic
        personal: $personal
        phones: $phones
        photo: $photo
        positionName: $positionName
        regionId: $regionId
        salaryFrom: $salaryFrom
        skills: $skills
        surname: $surname
        educationInfo: $educationInfo
        experienceInfo: $experienceInfo
        isDraft: $isDraft
      }
    ) {
      status
      ad {
        activationStatus
        approvedAt
        bumpedAt
        categoryId
        createdAt
        daysLeft
        deletable
        draft
        education
        educationId
        educationInfo
        experience
        experienceId
        experienceInfo
        expirable
        hits
        id
        isBookmarked
        isBumped
        isFeatured
        isMine
        location
        logo
        name
        personal
        positionName
        regionId
        rejectReason
        salaryFrom
        salaryTo
        skills
        status
        updatedAt
        awaitingPayment
        dateOfBirth
        description
      }
      errors {
        code
        message
        path
      }
    }
  }
`;

export const FREE_ACTIVATE_RESUME = gql`
  mutation FreeActivateResume($id: ID!) {
    freeActivateResume(id: $id) {
      status
      errors {
        code
        message
        path
      }
    }
  }
`;

export const DELETE_RESUME = gql`
  mutation DeleteAdResume($id: ID!, $adType: AdTypeEnum = RESUME) {
    deleteAd(input: { id: $id, adType: $adType }) {
      status
    }
  }
`;

export const CREATE_BOOKMARK_RESUME = gql`
  mutation createBookmarkResume($adId: ID!, $adType: AdTypeEnum = RESUME) {
    createBookmark(input: { id: $adId, adType: $adType }) {
      status
    }
  }
`;

export const DELETE_BOOKMARK_RESUME = gql`
  mutation deleteBookmarkResume($adId: ID!, $adType: AdTypeEnum = RESUME) {
    deleteBookmark(input: { id: $adId, adType: $adType }) {
      status
    }
  }
`;
